import type { ComponentProps } from 'react';

import { IconFigmaSelectArrow } from '@/assets/icons';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormSelect } from './FormField';
import { useFieldLayout } from './useFieldLayout';

type SelectFieldProps = Omit<
  ComponentProps<typeof FormSelect>,
  'label' | 'inputHeight' | 'inputBackground' | 'chevron'
> &
  FieldLayoutOptions;

export const SelectField = ({ label, hideLabel, ...selectProps }: SelectFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormSelect
      label={field.label}
      aria-label={field.ariaLabel}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      chevron={<IconFigmaSelectArrow size={16} color="var(--color-text-secondary)" />}
      {...selectProps}
    />
  );
};
